/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketItem } from '../../models/ticket-item';
import { TicketWithoutSerialNumberCreateDto } from '../../models/ticket-without-serial-number-create-dto';

export interface TicketControllerCreateTicketWithoutSerialNumber$Params {
      body: TicketWithoutSerialNumberCreateDto
}

export function ticketControllerCreateTicketWithoutSerialNumber(http: HttpClient, rootUrl: string, params: TicketControllerCreateTicketWithoutSerialNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerCreateTicketWithoutSerialNumber.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketItem;
      }>;
    })
  );
}

ticketControllerCreateTicketWithoutSerialNumber.PATH = '/ticket/create-ticket-without-serial';
